import { useQuery } from '@tanstack/react-query'

import { responsibleMedicalRecordInstance } from '../..'

export function getResponsibleMedicalRecordForViewQueryKey(id: string) {
  return ['responsibleMedicalRecordForView', id]
}

export function useGetResponsibleMedicalRecordForViewQuery({
  id,
  enabled
}: {
  id: string
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getResponsibleMedicalRecordForViewQueryKey(id),
    queryFn: async () =>
      await responsibleMedicalRecordInstance.getResponsibleMedicalRecordForView(
        { id }
      ),
    enabled
  })
}
